import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import middleware from "../../../Api/Middleware";
import "../css/AddProductPages.css";
import "../../../Main/Main.css";
import "../../product.css";
import ToastError from "../../../Toasts/ToastError";
import ToastSuccess from "../../../Toasts/ToastSuccess";
import NavbarIcon from "../../../Navbars/Sidebar/Icons/globe.png";
import { ButtonBlue, ButtonDarkBlue } from "../../../HouseStyle/Components/Buttons";
import { BackButton } from "../../../HouseStyle/Components/Buttons";
import { RegularCheckBox } from "../../../HouseStyle/Components/Checkboxes";
import ThirdBox from "../edit/edit_components/boxthird";
import PriceBox from "../edit/edit_components/boxPrice";
// Media
import PageTemplate from "../../../Templates/PageTemplate";

// boxes
import FirstBox from "../edit/edit_components/boxfirst";

import MediaUploaderComponent from "../../../MediaUpload/MediaUploaderComponent";
import Categories from "../sub_components/Categories";
import SalesChannelsBox from "../sub_components/SalesChannelsBox";
import LoadingIcon from "../../../HouseStyle/Components/LoadingIcon";
import ShippingInfoBox from "../edit/edit_components/ShippingInfoBox";

const AddSimple = () => {
  // Navigation hook
  const navigate = useNavigate();

  // Button
  const [buttonPressed, setbuttonPressed] = useState(null);
  const [brands, setBrands] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [refetch, setRefetch] = useState(false);

  // Selected brand, Channels, Sales, Genders, Barcode
  const [brandId, setBrandId] = useState(null);
  const [salesChannels, setSalesChannels] = useState([]);
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
  const [genders, setGenders] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [duplicateInstalled, setDuplicateInstalled] = useState(JSON.parse(localStorage.getItem("appstore")));
  const [productMeasurementsInstalled, setProductMeasurementsInstalled] = useState(() => {
    const appstore = JSON.parse(localStorage.getItem("appstore"));
    return appstore?.apps?.find(app => app.slug === "product-measurements")?.status === 3;
  });
  const [seasons, setSeasons] = useState([]);
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);

  const [barcode, setBarcode] = useState("");
  const [generatedBarcode, setGeneratedBarcode] = useState("");

  // Tax state
  const [tax, setTax] = useState(null);
  const [selectedTax, setSelectedTax] = useState(null);
  const [taxClass, setTaxClass] = useState(null);
  const [taxSettings, setTaxSettings] = useState(null);

  const [color,setColor]=useState(-1);
  const [size,setSize]=useState(-1);

  const [images, setImages] = useState([]);
  const [status, setStatus] = useState(true);
  const [stock, setStock] = useState({});
  const [selectedOption, setSelectedOption] = useState("0");
  const [categories, setCategories] = useState([]);

  const [values, setValues] = useState({
    product_name: "",
    product_number: "",
    barcode: "",
    weight: "",
    length: "",
    width: "",
    height: ""
  });
  // State for holding categories.
  const [initialCategories, setInitialCategories] = useState([
    { id: 1, headId: null, name: "Categories" },
  ]);

  const [checkedCategories, setCheckedCategories] = useState({});
  const [prices, setPrices] = useState([]);
  const [priceMargin, setPriceMargin] = useState();
  const [updatedTax, setUpdatedTax] = useState(false);

  const blobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        const commaIndex = reader.result.indexOf(',');
        resolve(reader.result.substring(commaIndex + 1));
      };
      reader.onerror = (error) => reject(error);
    });

  const validateImages = async () => {
    let faultyImages = false;
    for (let index = 0; index < images.length; index++) {
      const CurrentImage = images[index];
      if (CurrentImage.error) {
        faultyImages = true;
      }
    }
    if (faultyImages) {
      return "Verwijder de foto's die ongeldig zijn voordat je opslaat.";
    }

    return true;
  };

  const saveImages = async (productID) => {
    try {
      let currentProductId = productID;
      const currentMonth = (new Date().getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const currentYear = new Date().getFullYear();
      const folderPath = `warehouse/uploads/${currentYear}/${currentMonth}/${currentProductId}`;

      let bulkDataString = "";
      let imagestrings = [];

      //Loop through the images
      for (let index = 0; index < images.length; index++) {
        const CurrentImage = images[index];
        const base64String = await blobToBase64(CurrentImage.file);
        imagestrings.push(base64String);

        bulkDataString += `${CurrentImage.name
          }|${null}|${folderPath}/${CurrentImage.name.replace(/\s/g, "_")}|${index + 1
          }|${null}`;
        if (index < images.length - 1) {
          bulkDataString += ",";
        }
      }
      await middleware.post(
        `products/media/upload?product_id=${currentProductId}&bulk_data=${encodeURIComponent(
          bulkDataString
        )}`,
        { imagestrings: imagestrings }
      );
      return true;
    } catch (error) {
      return (
        error.response?.data?.Message ?? error.response?.data?.error ?? false
      );
    }
  };

  const saveSeasons = async (productID) => {
    try {
      if (selectedSeasons.length > 0) {
        const bulkData = selectedSeasons.map(seasonId => ({
          product_id: productID,
          season_id: seasonId
        }));

        await middleware.post(`products/hasseasons`, {
          bulk_data: bulkData
        });
      }
      return true;
    } catch (error) {
      console.error("Error saving seasons:", error);
      return false;
    }
  };

  const validate = (e) => {
    e.target.checkValidity();
    e.target.reportValidity();
  };

  const handleGenerateBarcode = async () => {
    // Generate a 13-digit barcode
    try {
      const res = await middleware.get("products/generateBarcode");
      const barcode = res.data.generatedBarcode;
      return barcode;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const updateBarcode = async () => {
      if (selectedOption === "0") {
        // Custom barcode, do nothing
        setBarcode(values.barcode);
      } else if (selectedOption === "2") {
        // Generated barcode
        if (!generatedBarcode) {
          const newBarcode = await handleGenerateBarcode();
          setGeneratedBarcode(newBarcode);
          setBarcode(newBarcode);
        } else {
          setBarcode(generatedBarcode); // reuse previously generated barcode
        }
      } else if (selectedOption === "3") {
        // Use product number
        setBarcode(values.product_number);
      }
    };

    updateBarcode();
  }, [selectedOption, values.product_number, values.barcode, generatedBarcode]);

  const proccessCategorieIds = (obj) => {
    const regex = /^(\d+)-(\d+)-(\d+)$/;
    const categoryIds = [];
    const HeadIds = [];

    Object.entries(obj)
      .filter(([key, value]) => value === true && regex.test(key))
      .forEach(([key]) => {
        const match = key.match(regex);
        if (match) {
          categoryIds.push(match[2]); // Voeg het derde deel toe aan match3
          HeadIds.push(match[3]); // Voeg het vierde deel toe aan match4
        }
      });
    return {
      categoryIds,
      HeadIds,
    };
  };

  const handleChange = (event) => {
    event.preventDefault();
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleBarcodeChange = (event) => {
    event.preventDefault();
    setBarcode(event.target.value);

    // If the user edits a custom barcode, reset generated one
    if (selectedOption === "0") {
      setGeneratedBarcode("");
    }
  };

  const handleGendersChange = (event) => {
    const valueAsInt = parseInt(event.target.value, 10); // Zet de waarde om naar een integer

    if (event.target.checked) {
      setSelectedGenders([...selectedGenders, valueAsInt]); // Voeg de integer waarde toe
    } else {
      setSelectedGenders(selectedGenders.filter((e) => e !== valueAsInt)); // Verwijder de integer waarde
    }
  };

  const handleSalesChannelsChange = (event) => {
    const valueAsInt = parseInt(event.target.value, 10); // Zet de waarde om naar een integer

    if (event.target.checked) {
      setSelectedSalesChannels([...selectedSalesChannels, valueAsInt]); // Voeg de integer waarde toe
    } else {
      setSelectedSalesChannels(
        selectedSalesChannels.filter((e) => e !== valueAsInt)
      );
    }
  };

  const fetchAll = async () => {
    try {
      const [fetchBrands, fetchCategories, fetchGenders, fetchSalesChannels, fetchSeasons, fetchColors, fetchSizes] =
        await Promise.all([
          middleware.get(`products/brands?status=1`),
          middleware.get(`products/category`),
          middleware.get(`products/genders`),
          middleware.get("saleschannels?status=1"),
          middleware.get("products/seasons?status=1"),
          middleware.get("products/colors?status=1"),
          middleware.get("products/sizes?status=1"),
        ]);
      const cat = fetchCategories.data.data.map((map) => {
        return {
          primary_key: map.primary_key,
          id: map.category_id,
          headId: map.head_category_id,
          name: map.title,
        };
      });
      setInitialCategories(cat);
      setBrands(fetchBrands.data.data);
      setCategories(fetchCategories.data.data);
      setGenders(fetchGenders.data.data);
      setSalesChannels(fetchSalesChannels.data.data);
      setSeasons(fetchSeasons.data.data || []);
      setColors(fetchColors.data.data || []);
      setSizes(fetchSizes.data.data || []);
    } catch (error) {
      console.error("Error fetching data:", error); 
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleFormKeyDown = (e) => {
    if (e.key !== 'Enter') return;

    const tag = (e.target?.tagName || '').toLowerCase();

    const inputType = e.target.type || '';
    if (tag === 'button' && inputType === 'submit') return;
    if (tag === 'input' && inputType === 'submit') return;

    if (tag === 'input' || tag === 'select') {
      e.preventDefault();
    }
  };

  const submitNew = async (event) => {
    // Parse price values for validation
    const standardPriceObj = prices.find(p => p.type === "price");
    const salePriceObj = prices.find(p => p.type === "sale_price");
    const inclVAT = standardPriceObj && standardPriceObj.incl_tax !== undefined;
    const standardPrice = standardPriceObj ? parseFloat((inclVAT ? standardPriceObj.incl_tax : standardPriceObj.excl_tax).toString().replace(",", ".")) : null;
    const salePrice = salePriceObj ? parseFloat((inclVAT ? salePriceObj.incl_tax : salePriceObj.excl_tax).toString().replace(",", ".")) : null;
    
    event.preventDefault();

    if (submitting) {
      return;
    }

    setSubmitting(true);
    
    const categoryIds = proccessCategorieIds(checkedCategories).categoryIds;
    
    const newprices = prices.reduce((acc, curr) => {
      acc[curr.type] = {
        price_id: curr.price_id,
        incl_tax:
          typeof curr.incl_tax === "string"
            ? Number(curr.incl_tax.replace(",", ".")).toFixed(2)
            : Number(curr.incl_tax).toFixed(2),
        excl_tax:
          typeof curr.excl_tax === "string"
            ? Number(curr.excl_tax.replace(",", ".")).toFixed(2)
            : Number(curr.excl_tax).toFixed(2),
      };
      return acc;
    }, {});

    let product_id;
    try {
      const validate = await validateImages();
      if (validate !== true) {
        ToastError(validate);
        setbuttonPressed(null);
        setSubmitting(false);
        return false;
      }

      const productName = values.product_name;
      if (productName == null || productName.trim() == "") {
        ToastError("Product naam is verplicht");
        setbuttonPressed(null);
        setSubmitting(false);
        return false;
      }

      // Only validate price relationship if both prices are filled in
      // Allow creation with no prices or only one price
      const hasValidStandardPrice = standardPrice !== null && standardPrice > 0;
      const hasValidSalePrice = salePrice !== null && salePrice > 0;
      
      if (hasValidStandardPrice && hasValidSalePrice && salePrice >= standardPrice) {
        ToastError("De kortingsprijs moet lager zijn dan de standaard prijs. Product kan nog niet worden aangemaakt.");
        setbuttonPressed(null);
        setSubmitting(false);
        return false;
      }

      const maxBarcodeLength=25;
      if(barcode && barcode.length>maxBarcodeLength){
        ToastError("De barcode mag niet langer zijn dan "+maxBarcodeLength+" karakters");
        setbuttonPressed(null);
        setSubmitting(false);
        return false;
      }
      await middleware
        .post(`products/create`, {
          product: {
            name: values.product_name,
            number: values.product_number,
            barcode: barcode,
            tax_class: taxSettings.globalTaxClass,
            description: values.product_description,
            status: status,
            weight: values.weight || null,
            length: values.length || null,
            width: values.width || null,
            height: values.height || null,
          },
          prices: newprices,
          category_ids: categoryIds,
          gender_ids: selectedGenders,
          sales_channel_ids: selectedSalesChannels,
          brand_id: brandId,
          stock: stock,
          color: color,
          size: size,
        })
        .then(async (e) => {
          product_id = e.data.product.product_id;
          await saveImages(product_id);
          await saveSeasons(product_id);
          
          // Sla tax overrides op als ze bestaan
          if (taxSettings && Object.keys(taxSettings.countryOverrides).length > 0) {
            const formattedOverrides = Object.entries(taxSettings.countryOverrides)
              .map(([countryCodeId, taxClass]) => ({
                country_code_id: parseInt(countryCodeId),
                tax_class: taxClass
              }));

            await middleware.post('products/updateTaxRates', {
              product_id: product_id,
              global_tax_class: taxSettings.globalTaxClass,
              country_overrides: formattedOverrides
            });
          }
        });

      ToastSuccess("Product is aangemaakt");
      if (buttonPressed == 1) {
        // Reset every thing and make sure that things get refetch what doesn't want to rerendeder
        // Selected brand, Channels, Sales, Genders, Barcode
        setBrandId(null);
        setSelectedSalesChannels([]);
        setSelectedGenders([]);
        setSelectedSeasons([]);
        setBarcode("");
        setImages([]);
        setStock({});
        setValues({
          product_name: "",
          product_number: "",
          barcode: "",
          product_description: "",
        });
        setStatus(true);
        setRefetch(!refetch);
        setCheckedCategories({});
        setPrices([]);
        setPriceMargin();
        setColor(-1);
        setSize(-1);
      } else if (buttonPressed == 2) {
        setValues((prevValues) => ({
          ...prevValues,
          product_number: "",
        }));
        setBarcode("");
        setSelectedOption("0");
        setStock({});
        window.scrollTo(0, 0);
        setTimeout(() => {
          setbuttonPressed(null);
        }, 2000);
      } else if (buttonPressed == 3) {
        navigate("/producten/bewerken/" + product_id+window.location.search);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.details) {
        const details = err.response.data.details;

        if (details["product.number"]) {
          ToastError(`Productnummer bestaat al`);
          setSubmitting(false);
          return;
        }
        if (details["product.barcode"]) {
          if(details["product.barcode"][0].includes('formaat')) ToastError('Barcode heeft een ongeldige formaat. Zorg ervoor dat het alleen uit nummers en letters bestaat!!!');
          else ToastError("Barcode bestaat al");
          setSubmitting(false);
          return;
        }
      } else {
        console.error(err);
      }
      ToastError("Er is een fout opgetreden bij het aanmaken van het product.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleTaxSettingsChange = (settings) => {
    setSelectedTax(Number(settings.currentTaxRate));
    setTaxSettings(settings);
  };

  return (
    <PageTemplate navbarTitle={"Warehouse HUB"} iconNavbar={NavbarIcon}>
      <form
        onSubmit={submitNew}
        onKeyDown={handleFormKeyDown}
        method="post"
        className="d-flex justify-content-center minFitContent w-100"
      >
        <div className="mb-3 d-flex flex-column formItems  minFitContent w-100">
          <div className="d-flex justify-content-between mb-4 w-100 flex-wrap">
            <div className="d-flex gap-5 w-md-100 navigation-and-status">
              <BackButton
                text={"Terug"}
                disabled={false}
                onClickFunction={() => navigate("/producten"+window.location.search)}
              />
              {/* Published btn*/}
              <div className="d-flex flex-column align-items-center">
                {status ? (
                  <p className="mb-1 p-0">Gepubliceerd</p>
                ) : (
                  <p className="mb-1 p-0">Gearchiveerd</p>
                )}
                <label className="switchActiveProduct">
                  <input
                    type="checkbox"
                    checked={status}
                    onChange={(e) => setStatus(e.target.checked)}
                  />
                  <span className="sliderActiveProduct round"></span>
                </label>
              </div>
            </div>
            <div className="d-flex gap-3 CreateButtons w-md-100">
              <ButtonDarkBlue
                type="submit"
                className="btn darkBlueStandardButton me-3 Nunito w-auto px-5"
                onClickFunction={(e) => setbuttonPressed(1)}
                text={"Aanmaken en nieuwe toevoegen"}
                disabled={submitting}
              />
              {duplicateInstalled?.apps?.find(
                (app) => app.slug === "duplicate-products",
              )?.status === 3 ? (
                <ButtonDarkBlue
                  type="submit"
                  disabled={submitting}
                  className="btn darkBlueStandardButton me-3 Nunito w-auto px-5"
                  onClickFunction={(e) => setbuttonPressed(2)}
                  text={"Aanmaken en standaard waardes kopiëren"}
                />
              ) : null}
              <ButtonBlue
                type="submit"
                text={"Aanmaken"}
                onClickFunction={(e) => setbuttonPressed(3)}
                disabled={submitting}
              />
            </div>
          </div>
          {submitting ? (
            <div
              className=" mb-4 d-flex align-items-center flex-column"
              role="alert"
            >
              <div>
                <LoadingIcon color="#009fe3" size={80} />
              </div>
              Nieuw concept product wordt aangemaakt
            </div>
          ) : (
            <div className="d-flex flex-column flex-xxl-row justify-content-between">
              <div className="col-xxl-8 col-12 mb-md-3">
                <div>
                  <div className="d-flex flex-column fitcontentHeight mb-3 mb-md-3">
                    <FirstBox
                      handleChange={handleChange}
                      product={values}
                      setProduct={setValues}
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                      brands={brands}
                      barcode={barcode}
                      setBarcode={setBarcode}
                      validate={validate}
                      setBrandId={setBrandId}
                      brandId={brandId}
                      handleBarcodeChange={handleBarcodeChange}
                      edit={false}
                      setColor={setColor}
                      setSize={setSize}
                      colors={colors}
                      sizes={sizes}
                      color={color}
                      size={size}
                    />
                  </div>
                </div>

                {productMeasurementsInstalled && (
                  <div className="mt-4">
                    <ShippingInfoBox
                      product={values}
                      setProduct={setValues}
                      setUpdatedProduct={() => {}}
                    />
                  </div>
                )}

                <div className="mt-4">
                  <MediaUploaderComponent
                    edit={false}
                    setImages={setImages}
                    images={images}
                  ></MediaUploaderComponent>
                </div>
              </div>
              <div className="d-flex flex-column flex-xxl-column col-12 col-xxl-4 sidebar-cards-container">
                {/* category */}
                <div className="col-12 col-xxl-12 mb-3 category-box-add-product">
                  <div className="whiteBox p-0">
                    {categories != null && categories.length ? (
                      <Categories
                        initialCategories={initialCategories}
                        setCheckedCategories={setCheckedCategories}
                        checkedCategories={checkedCategories}
                      />
                    ) : (
                      <div className="whiteBox boxCategories">
                        <div className="d-flex flex-column">
                          <div className=" widthBoxes w-100 p-3 categories">
                            <div className="d-flex justify-content-between flex-column">
                              <h5 className="inputTitle mb-3">Categorieën</h5>
                              <p>Er zijn geen categorieën gevonden</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* gender */}
                <div className="col-12 col-xxl-12 mb-3">
                  <div className="whiteBox p-5">
                    <h5 className="inputTitle mb-3">Geslacht</h5>
                    <div>
                      {genders.map((gender, index) => (
                        <div key={index} className="d-flex flex-row mb-2">
                          <RegularCheckBox
                            label={gender.name}
                            value={
                              selectedGenders.find(
                                (g) => g === gender.gender_id,
                              ) || false
                            }
                            setValue={(checked) => {
                              const event = {
                                target: {
                                  value: gender.gender_id,
                                  checked: checked,
                                },
                              };
                              handleGendersChange(event);
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* seasons */}
                <div className="col-12 col-xxl-12 mb-3">
                  <div className="whiteBox p-5">
                    <h5 className="inputTitle mb-3">Seizoenen</h5>
                    <div className="scrollable-seasons-container">
                      {seasons.length === 0 ? (
                        <p className="text-muted">Geen seizoenen beschikbaar</p>
                      ) : (
                        seasons.map((season, index) => (
                          <div key={index} className="d-flex flex-row mb-2">
                            <RegularCheckBox
                              label={
                                season.sub_season
                                  ? `${season.head_season} - ${season.sub_season}`
                                  : season.head_season
                              }
                              value={selectedSeasons.includes(season.season_id)}
                              setValue={(checked) => {
                                if (checked) {
                                  setSelectedSeasons([
                                    ...selectedSeasons,
                                    season.season_id,
                                  ]);
                                } else {
                                  setSelectedSeasons(
                                    selectedSeasons.filter(
                                      (id) => id !== season.season_id,
                                    ),
                                  );
                                }
                              }}
                            />
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
                {/* prices component */}
                <div className="col-12 col-xxl-12 mb-3">
                  <PriceBox
                    refetch={refetch}
                    selectedTax={selectedTax}
                    setSelectedTax={setSelectedTax}
                    setTax={setTax}
                    taxClass={taxClass}
                    setTaxClass={setTaxClass}
                    handleChange={handleChange}
                    prices={prices}
                    setPrices={setPrices}
                    priceMargin={priceMargin}
                    setPriceMargin={setPriceMargin}
                    validate={validate}
                    edit={false}
                    product={values}
                    onTaxSettingsChangeCallback={handleTaxSettingsChange}
                  />
                </div>
                {/* Stock */}
                <div className="mb-3 col-12 col-xxl-12">
                  <ThirdBox
                    stock={stock}
                    setStock={setStock}
                    validate={validate}
                    edit={false}
                  />
                </div>

                {/* sales channels */}
                <div className="col-12 col-xxl-12 mb-3">
                  <SalesChannelsBox
                    salesChannels={salesChannels}
                    selectedSalesChannels={selectedSalesChannels}
                    handleSalesChannelsChange={handleSalesChannelsChange}
                  />
                </div>
                {/* Suppliers */}
                {/* <div className="pb-4 col-6 col-xxl-12">
                <FourthBox
                  suppliers={suppliers}
                  setSuppliers={setSuppliers}
                  businesses={businesses}
                  setBusinesses={setBusinesses}
                  validate={validate}
                  attributeConnections={attributeConnections}
                  setAttributeConnections={setAttributeConnections}
                  edit={false}
                />
              </div> */}
              </div>
            </div>
          )}
        </div>
      </form>
    </PageTemplate>
  );
};

export default AddSimple;
